import SignInModel from 'src/model/modules/signin.model';

const moduleSel = (state: any): SignInModel => state.signin;

export const isLoggedInSel = (state: any) => moduleSel(state).success;
export const activeAccountSel = (state: any) => moduleSel(state).activeAccount;
export const activeAccountCountrySel = (state: any) =>
  moduleSel(state).activeAccountCountry;
export const shouldSelectAccountSel = (state: any) =>
  moduleSel(state).shouldSelectAccount;
export const shouldVerifySel = (state: any) => moduleSel(state).shouldVerify;
export const shouldUpdateInfoSel = (state: any) =>
  moduleSel(state).shouldUpdateInfo;
export const signInPendingSel = (state: any) => moduleSel(state).pending;
export const signinFailedSel = (state: any) =>
  moduleSel(state).failed.hasFailed;
export const signinErrorSel = (state: any) => moduleSel(state).failed.message;
export const accountHasChangedSel = (state: any) =>
  moduleSel(state).activeAccountHasChanged;
export const samsungUserSel = (state: any) =>
  moduleSel(state).navigateToSamsungInvoicePage;
